export default "__VITE_ASSET__D127Smkq__"